export const EXISTING_TERMS_LIST_VARIANTS = {
  FORM: 'FORM',
  PAGE: 'PAGE',
};
